import React from 'react';
import { Form, Input, Row, SonForm, SubmitButton, TextParam, useForm } from '../../../_lib/Form2';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { RowModifier } from '../../../_lib/Form2/grid/Row/Row';

export type ConfirmEmailAddressFormTypes = TextParam<'currentPassword'>;

type ConfirmEmailAddressFormProps = {
  form: SonForm<ConfirmEmailAddressFormTypes>;
  newEmailAddress: string;
};

export function ConfirmEmailAddressForm({ form, newEmailAddress }: ConfirmEmailAddressFormProps) {
  const id = useHtmlValidId();
  const { formProps, fetchState, params } = useForm({ form });
  const { t } = useSonTranslation('ChangeEmailAddress');

  const currentPasswordParam = params.findByName('currentPassword');

  return (
    <Form {...formProps} id={`confirm-email-address-form-${id}`}>
      <Row modifier={RowModifier.BLOCK}>
        <ContentParagraph>{`${t('confirmEmail.hint')}`}</ContentParagraph>
        <ContentParagraph>
          {t('confirmEmail.newMail')}: <Strong>{newEmailAddress}</Strong>
        </ContentParagraph>
      </Row>
      {currentPasswordParam && (
        <Row>
          <Input label={t('confirmEmail.currentPassword')} param={currentPasswordParam} />
        </Row>
      )}
      <SubmitButton
        buttonLabel={t('confirmEmail.submit')}
        messageSuccess={t('confirmEmail.status.success')}
        messageSending={t('confirmEmail.status.sending')}
        messageFail={t('confirmEmail.status.fail')}
        fetchState={fetchState}
        customErrorTypeMessages={{
          itemAlreadyExists: t('errorType.itemAlreadyExists'),
          invalidPassword: t('errorType.invalidPassword'),
        }}
        disabled={fetchState.type === 'loading' || fetchState.type === 'success'}
      />
    </Form>
  );
}
